import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LocationService } from 'src/app/services/location.service';
import { event } from 'jquery';
@Component({
  selector: 'packaging-awb',
  templateUrl: './packaging-awb.component.html',
  styleUrls: ['./packaging-awb.component.scss'],
  animations: [
      trigger('openClose', [
        state('open', style({
          opacity: 1,
          display: 'block'
        })),
        state('closed', style({
          opacity: 0,
          display: 'none'
        })),
        transition('open => closed', [
          animate('0.5s')
        ]),
        transition('closed => open', [
          animate('0.5s')
        ]),
      ]),
    ]
})
export class PackagingAwbComponent implements OnChanges, OnDestroy {
  @Output() PackagingAwb = new EventEmitter<boolean>();
  @Output() PackagingPrice = new EventEmitter();
  @Input() changing;
  @Input() enableChange;

  packagingSmall : string = '';
  packagingMedium : string = '';
  packagingLarge : string = '';
  BranchCurrencyCode: string = '';
  isOpen: boolean = false;
  selectedPackaging: string;
  size:string
  locationId: any;
  @Output() selectedSize = new  EventEmitter<boolean>();
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true){
        this.isOpen = change;    
      }
      if (this.isOpen == false){
        this.PackagingAwb.emit(false);
      }
    }
  }

  ngOnDestroy(): void {
    this.selectedSize.emit(false);
  }

  constructor( private locationService: LocationService) { }
  ngOnInit(): void {
    this.getShipmentSizePrice();
  }


  change() {
    this.isOpen = true;
  }


    getShipmentPackagingPrices(size: 'Small' | 'Medium' | 'Large') {
      this.locationService.getPackagingPrices(
          (res) => {
              if (res?.Results?.[0]?.[size]) {
                  this.selectedPackaging = res.Results[0][size];
                  this.selectedSize.emit(true);
                  this.PackagingPrice.emit(this.selectedPackaging);
                  
              } else {
                  console.error(`Size ${size} not found in the response`, res);
              }
          },
          (err) => {
              console.error('Error fetching packaging prices:', err);
          }
      );
    }

    getShipmentSizePrice(){
      this.locationService.getPackagingPrices((res) => { 
        this.packagingSmall = res.Results[0].Small;
        this.packagingMedium = res.Results[0].Medium;
        this.packagingLarge = res.Results[0].Large;
        this.BranchCurrencyCode =JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
       }, (err) => { })

    }


  
}
